import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.scss']
})
export class PressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
